export default "__VITE_ASSET__CiKR$lET__"